import Slider from './Slider';
import { sliderFotos } from "../SliderData/SliderDataHome";

export const SliderRegular = () => {
    return (<Slider list={sliderFotos}/>)
};
